import { SimulatedDebt } from '@common/apis/simulated-debt/types';
import { SortingDebtResult } from '@common/apis/sorting-debt/types';
import { FormattedDebt } from '@common/contexts/DebtsContext/types';


export const getShouldUseMagaluBrandDebt = (partner: string, debt: SortingDebtResult | FormattedDebt | SimulatedDebt | any) => {
  const safePartner = partner || ""
  const isItau = safePartner.includes('itau');

  if (!isItau || !debt) return false;

  //@ts-ignore
  const debtProduct = debt?.product || debt?.produto || '';
  const isLegacyLuizacredProduct = debtProduct.includes('LUIZACRED');

  if (isLegacyLuizacredProduct) return true;

  //@ts-ignore
  const props = debt?.properties || debt?.propriedades || [];

  return props.some((p: any) => {
    const key = p.key || p.chave;
    const value = p.booleanValue || p.valorBoolean || false;
    return key === 'IS_MAGAZINE_LUIZA_DEBT' && !!value;
  });
};
